import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Apple, Smartphone, Edit, History } from "lucide-react";



const statusColors = {
  development: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  testing: "bg-yellow-500/10 text-yellow-600 border-yellow-500/20",
  production: "bg-green-500/10 text-green-600 border-green-500/20",
  archived: "bg-gray-500/10 text-gray-600 border-gray-500/20",
};

export function AppCard({ app, onEdit, onViewHistory }) {
  return (
    <Card className="p-4 hover:shadow-lg transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-xl">
            {app.icon}
          </div>
          <div>
            <h3 className="font-semibold">{app.name}</h3>
            <p className="text-sm text-gray-500">
              Updated {new Date(app.lastUpdated).toLocaleDateString()}
            </p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewHistory(app)}
        >
          <History className="w-4 h-4" />
        </Button>
      </div>

      <div className="space-y-4">
        {/* iOS Version */}
        <div className="border rounded-lg p-3">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Apple className="w-5 h-5" />
              <span className="font-medium">iOS</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onEdit(app, "ios")}
            >
              <Edit className="w-4 h-4" />
            </Button>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Version</span>
              <span className="font-mono font-medium">{app.iosVersion}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Build</span>
              <span className="font-mono text-sm">{app.iosBuildNumber}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Status</span>
              <Badge className={statusColors[app.iosStatus]} variant="outline">
                {app.iosStatus}
              </Badge>
            </div>
          </div>
        </div>

        {/* Android Version */}
        <div className="border rounded-lg p-3">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Smartphone className="w-5 h-5" />
              <span className="font-medium">Android</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onEdit(app, "android")}
            >
              <Edit className="w-4 h-4" />
            </Button>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Version</span>
              <span className="font-mono font-medium">{app.androidVersion}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Build</span>
              <span className="font-mono text-sm">{app.androidBuildNumber}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Status</span>
              <Badge className={statusColors[app.androidStatus]} variant="outline">
                {app.androidStatus}
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
